/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Free_VoicesInputs */

const en_mobile_free_voices = /** @type {(inputs: Mobile_Free_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free voices`)
};

const es_mobile_free_voices = /** @type {(inputs: Mobile_Free_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces gratis`)
};

/**
* | output |
* | --- |
* | "Free voices" |
*
* @param {Mobile_Free_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_free_voices = /** @type {((inputs?: Mobile_Free_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Free_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_free_voices(inputs)
	return en_mobile_free_voices(inputs)
});